import { usePermissions } from '@refinedev/core'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function useRouteGuard(allowedPermissions: string[]) {
  const { data: permissions, isLoading } = usePermissions<
    'Full' | 'Orgs Users' | null
  >()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && permissions) {
      const userPermission = permissions

      // If user has no permissions or permissions not in allowed list
      if (!userPermission || !allowedPermissions.includes(userPermission)) {
        // Redirect to dashboard
        navigate('/', { replace: true })
      }
    }
  }, [permissions, isLoading, allowedPermissions, navigate])

  return {
    hasAccess: permissions ? allowedPermissions.includes(permissions) : false,
    isLoading,
    userPermissions: permissions,
  }
}
